import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import SydSelect from '../../../../../../../commonDesign/SydSelect'
import SydCheckbox from '../../../../../../../commonDesign/SydCheckbox'

function ItemMigrationMappingGroup ({
  label,
  keyName,
  statusReport,
  rows,
  options
}) {
  const form = useFormContext()

  // Watch the entire group once to trigger re-renders properly
  const groupValues = form.watch(`itemMigrationMapping.${keyName}`) || {}

  if (!rows?.length || !options?.length) return null

  return (
    <div className='flex flex-col gap-2 radius-md bg-neutral-100 border-neutral-300 border p-2'>
      <div className='font-size-xs font-bold'>{label}</div>
      <div className='flex flex-col flex-1 gap-2'>
        {rows.map((oldCodeName) => {
          const baseFormPath = `itemMigrationMapping.${keyName}.${oldCodeName}`
          const currentItem = statusReport.items.find(item => item.codeName === oldCodeName)
          const enabled = groupValues[oldCodeName]?.enabled ?? true

          return (
            <div
              key={`${keyName}-${oldCodeName}-row`}
              className={clsx(
                'flex justify-between items-center py-1 p-2 border bg-surface-050 rounded',
                { 'opacity-lowlighted': enabled === false }
              )}
            >
              <div className='flex items-center gap-1'>
                <Controller
                  key={`${keyName}-${oldCodeName}-enabled`}
                  control={form.control}
                  name={`${baseFormPath}.enabled`}
                  render={({ field }) => (
                    <SydCheckbox
                      {...field}
                      checked={!!field.value}
                    />
                  )}
                />
                <span
                  className='font-size-xs'
                  style={{ cursor: 'pointer' }}
                  onClick={() => form.setValue(`${baseFormPath}.enabled`, !form.getValues(`${baseFormPath}.enabled`), { shouldDirty: true })}
                >
                  {currentItem.displayName ?? keyName}
                </span>
              </div>
              <Controller
                key={`${keyName}-${oldCodeName}-matching`}
                control={form.control}
                name={`${baseFormPath}.matching`}
                render={({ field, fieldState }) => (
                  <SydSelect
                    {...field}
                    value={field.value ?? ''}
                    placeholder='Do not copy'
                    options={options}
                    size='xs'
                    disabled={!enabled}
                  />
                )}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

ItemMigrationMappingGroup.propTypes = {
  label: PropTypes.string.isRequired,
  keyName: PropTypes.string.isRequired,
  statusReport: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired
}

export default ItemMigrationMappingGroup
